module.exports = __webpack_public_path__ + "lk.svg?f4a88527a0f631e816bfa30b4dfd900e";